import { Directive, ElementRef, Input, Renderer2 } from '@angular/core';
import {
  LayoutDirective as FlexLayoutLayoutDirective,
  MediaMonitor,
} from '@angular/flex-layout';

@Directive({
  selector: `
    [flLayout],
    [flLayout.mobile],
    [flLayout.tablet],
    [flLayout.desktop-small],
    [flLayout.desktop-large],
    [flLayout.desktop-xlarge],
    [flLayout.desktop-xxlarge],
  `,
})
export class LayoutDirective extends FlexLayoutLayoutDirective {
  constructor(monitor: MediaMonitor, elRef: ElementRef, renderer: Renderer2) {
    super(monitor, elRef, renderer);
  }

  @Input('flLayout')
  set layout(val: any) {
    this._cacheInput('layout', val);
  }
  @Input('flLayout.mobile')
  set layoutMobile(val: any) {
    this._cacheInput('layoutMobile', val);
  }
  @Input('flLayout.tablet')
  set layoutTablet(val: any) {
    this._cacheInput('layoutTablet', val);
  }
  @Input('flLayout.desktop-small')
  set layoutDesktopSmall(val: any) {
    this._cacheInput('layoutDesktopSmall', val);
  }
  @Input('flLayout.desktop-large')
  set layoutDesktopLarge(val: any) {
    this._cacheInput('layoutDesktopLarge', val);
  }
  @Input('flLayout.desktop-xlarge')
  set layoutDesktopXLarge(val: any) {
    this._cacheInput('layoutDesktopXLarge', val);
  }
  @Input('flLayout.desktop-xxlarge')
  set layoutDesktopXXLarge(val: any) {
    this._cacheInput('layoutDesktopXXLarge', val);
  }
}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-i18n-webapp-compat/LANG/de/webapp/src/app/@shared/ui/layout/layout.directive.ts